/// <reference path="../../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class SchemeEnrollmentSelectGrid extends _Ext.GridBase<Scheme.SchemeEnrollmentRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemeSelect'; }
        protected getDialogType() { return Scheme.SchemeEnrollmentDialog; }
        protected getIdProperty() { return Scheme.SchemeEnrollmentRow.idProperty; }
        protected getInsertPermission() { return Scheme.SchemeEnrollmentRow.insertPermission; }
        protected getLocalTextPrefix() { return Scheme.SchemeEnrollmentRow.localTextPrefix; }
        protected getService() { return Scheme.SchemeSelectService.baseUrl; } 
        private autoSize;
         
       
        constructor(container: JQuery, options) {
            super(container, options);

            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                request.POSCustomerId = poscustomerid;
                //(this.view.params as StockListRequest).InStock = ECommOrderItemsSelectGrid.InStock;
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): Scheme.SchemeEnrollmentRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}